<template>
  <section class="contacts">
    <div class="container">
      <div class="contacts_wrap">
        <div class="left_col">
          <div class="section_top">
            <h1 v-text="h1" />
          </div>
          <div class="contacts_descr" v-html="page.description" />
          <div v-if="itemsShops.length" class="contacts_list">
            <div v-for="(shop, index) in itemsShops" :key="`${index}_shop`" class="contacts_item">
              <div class="shop_info">
                <div class="shop_address" v-text="$options.filters.transl(shop, 'address', $i18n.locale)" />
                <div class="shop_list">
                  <div v-if="shop.phone" class="shop_item">
                    <i class="icon_phone" />
                    <div class="shop_item_info">
                      <a :href="`tel:${shop.phone}`" class="title phone" v-text="shop.phone" />
                      <div class="descr">
                        <i class="kyivstar_icon" />
                        {{ $t('contacts.kyivstar') }}
                      </div>
                    </div>
                  </div>
                  <div v-if="shop.phone2" class="shop_item">
                    <i class="icon_phone" />
                    <div class="shop_item_info">
                      <a :href="`tel:${shop.phone2}`" class="title phone" v-text="shop.phone2" />
                      <div class="descr">
                        <i class="stationary_icon" />
                        {{ $t('contacts.stationary') }}
                      </div>
                    </div>
                  </div>
                  <div v-if="shop.phone3" class="shop_item">
                    <i class="icon_phone" />
                    <div class="shop_item_info">
                      <a :href="`tel:${shop.phone3}`" class="title phone" v-text="shop.phone3" />
                      <div class="descr">
                        <i class="vodafone_icon" />
                        {{ $t('contacts.vodafone') }}
                      </div>
                    </div>
                  </div>
                  <div v-if="shop.phone4" class="shop_item">
                    <i class="icon_phone" />
                    <div class="shop_item_info">
                      <a :href="`tel:${shop.phone4}`" class="title phone" v-text="shop.phone4" />
                      <div class="descr">
                        {{ $t('contacts.lifecell') }}
                      </div>
                    </div>
                  </div>
                  <div class="shop_item">
                    <i class="icon_time" />
                    <div class="shop_item_info">
                      <div class="title work_hours" v-html="$options.filters.transl(shop, 'schedule', $i18n.locale)" />
                      <div class="descr" v-html="$options.filters.transl(shop, 'schedule2', $i18n.locale)" />
                    </div>
                  </div>
                </div>
              </div>
              <client-only>
                <div class="shop_location" v-html="shop.href" />
              </client-only>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    page: {
      type: Object,
      default: null
    },
    h1: {
      type: String,
      default: ''
    }
  },
  computed: {
    ...mapGetters('settings', ['settings', 'shops']),
    itemsShops () {
      return this.shops ? this.shops.filter(s => s.id === this.page.shop_id) : []
    }
  }
}
</script>
